import React from "react";

interface AddRecordBatchStep3Props {
  message: string | null;
}

const AddRecordBatchStep3: React.FC<AddRecordBatchStep3Props> = ({
  message,
}) => {
  return (
    <div className="step-area">
      <div>
        <p className="success-message"> {message} </p> {/* Style the message */}
        {/* Add more details or actions here if needed */}
      </div>
    </div>
  );
};

export default AddRecordBatchStep3;
